const langDocumentExpertise = {
	link_go_to_expertise_synthesis: {
		tag: 'document.expertise.link_go_to_expertise_synthesis',
		fr: "Aller à la synthèse de l'expertise",
		en: 'Go to expertise synthesis',
	},
};

export default langDocumentExpertise;
